const shopifyCollectionEmbed = function (barba) {

	var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
	if (window.ShopifyBuy) {
		if (window.ShopifyBuy.UI) {
			ShopifyBuyInit();
		} else {
			loadScript();
		}
	} else {
		loadScript();
	}
	function loadScript() {
		var script = document.createElement('script');
		script.async = true;
		script.src = scriptURL;
		(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
		script.onload = ShopifyBuyInit;
	}
	function ShopifyBuyInit() {
		var client = ShopifyBuy.buildClient({
			domain: 'cowell-clarke.myshopify.com',
			storefrontAccessToken: '515c48e021a35f4961a82a4d47c9a54d',
		});
		ShopifyBuy.UI.onReady(client).then(function (ui) {
			ui.createComponent('collection', {
				id: '266286628908',
				node: document.getElementById('collection-component-1644811615196'),
				moneyFormat: '%24%7B%7Bamount%7D%7D',
				options: {
					"product": {
						"styles": {
							"product": {
								"@media (min-width: 601px)": {
									"max-width": "calc(25% - 20px)",
									"margin-left": "20px",
									"margin-bottom": "50px",
									"width": "calc(25% - 20px)"
								},
								"img": {
									"height": "calc(100% - 15px)",
									"position": "absolute",
									"left": "0",
									"right": "0",
									"top": "0"
								},
								"imgWrapper": {
									"padding-top": "calc(75% + 15px)",
									"position": "relative",
									"height": "0"
								}
							},
							"title": {
								"font-size": "20px",
								"color": "#005293"
							},
							"button": {
								"font-family": "Arial, sans-serif",
								"font-size": "16px",
								"padding-top": "16px",
								"padding-bottom": "16px",
								"color": "#005293",
								"text-transform": "uppercase",
								"font-weight": "bold",
								":hover": {
									"background-color": "#005293",
									"color": "#ffffff"
								},
								"background-color": "transparent",
								":focus": {
									"background-color": "transparent"
								},
								"border-color": "#005293",
								"border-style": "solid",
								"border-width": "1px",
								"border-radius": "40px",
								"padding-left": "50px",
								"padding-right": "50px"
							},
							"quantityInput": {
								"font-size": "16px",
								"padding-top": "16px",
								"padding-bottom": "16px"
							},
							"price": {
								"font-size": "16px"
							},
							"compareAt": {
								"font-size": "13.6px"
							},
							"unitPrice": {
								"font-size": "13.6px"
							}
						},
						"text": {
							"button": "Add to cart"
						},
						"googleFonts": [
							"Open Sans"
						]
					},
					"productSet": {
						"styles": {
							"products": {
								"@media (min-width: 601px)": {
									"margin-left": "-20px"
								}
							}
						}
					},
					"modalProduct": {
						"contents": {
							"img": false,
							"imgWithCarousel": true,
							"button": false,
							"buttonWithQuantity": true
						},
						"styles": {
							"product": {
								"@media (min-width: 601px)": {
									"max-width": "100%",
									"margin-left": "0px",
									"margin-bottom": "0px"
								}
							},
							"button": {
								"font-family": "Open Sans, sans-serif",
								"font-size": "16px",
								"padding-top": "16px",
								"padding-bottom": "16px",
								"color": "#005293",
								"text-transform": "uppercase",
								"font-weight": "bold",
								":hover": {
									"background-color": "#005293",
									"color": "#ffffff"
								},
								"background-color": "transparent",
								":focus": {
									"background-color": "transparent"
								},
								"border-color": "#005293",
								"border-style": "solid",
								"border-width": "1px",
								"border-radius": "40px",
								"padding-left": "50px",
								"padding-right": "50px"
							},
							"quantityInput": {
								"font-size": "16px",
								"padding-top": "16px",
								"padding-bottom": "16px"
							},
							"title": {
								"font-family": "Helvetica Neue, sans-serif",
								"font-weight": "bold",
								"font-size": "26px",
								"color": "#4c4c4c"
							},
							"price": {
								"font-family": "Helvetica Neue, sans-serif",
								"font-weight": "normal",
								"font-size": "18px",
								"color": "#4c4c4c"
							},
							"compareAt": {
								"font-family": "Helvetica Neue, sans-serif",
								"font-weight": "normal",
								"font-size": "15.299999999999999px",
								"color": "#4c4c4c"
							},
							"unitPrice": {
								"font-family": "Helvetica Neue, sans-serif",
								"font-weight": "normal",
								"font-size": "15.299999999999999px",
								"color": "#4c4c4c"
							}
						},
						"googleFonts": [
							"Open Sans"
						],
						"text": {
							"button": "Add to cart"
						}
					},
					"option": {},
					"cart": {
						"styles": {
							"button": {
								"font-family": "Arial, sans-serif",
								"font-size": "16px",
								"padding-top": "16px",
								"padding-bottom": "16px",
								"color": "#005293",
								"text-transform": "uppercase",
								"font-weight": "bold",
								":hover": {
									"background-color": "#005293",
									"color": "#ffffff"
								},
								"background-color": "transparent",
								":focus": {
									"background-color": "transparent"
								},
								"border-color": "#005293",
								"border-style": "solid",
								"border-width": "1px",
								"border-radius": "40px",
							},
							"title": {
								"color": "#005293",
								"font-weight": "bold",
							},
							"header": {
								"color": "#262226"
							},
							"lineItems": {
								"color": "#262226"
							},
							"subtotalText": {
								"color": "#262226"
							},
							"subtotal": {
								"color": "#262226"
							},
							"notice": {
								"color": "#262226"
							},
							"currency": {
								"color": "#262226"
							},
							"close": {
								"color": "#262226",
								":hover": {
									"color": "#262226"
								}
							},
							"empty": {
								"color": "#262226"
							},
							"noteDescription": {
								"color": "#262226"
							},
							"discountText": {
								"color": "#262226"
							},
							"discountIcon": {
								"fill": "#262226"
							},
							"discountAmount": {
								"color": "#262226"
							}
						},
						"text": {
							"total": "Subtotal",
							"button": "Checkout"
						},
						"popup": false,
						"googleFonts": [
							"Open Sans"
						]
					},
					"toggle": {
						"styles": {
							"toggle": {
								"font-family": "Open Sans, sans-serif",
								"background-color": "transparent",
								":hover": {
									"background-color": "transparent"
								},
								":focus": {
									"background-color": "transparent"
								}
							},
							"count": {
								"font-size": "16px",
								"color": "#005293",
								":hover": {
									"color": "#005293"
								}
							},
							"iconPath": {
								"fill": "#005293"
							}
						},
						"googleFonts": [
							"Open Sans"
						]
					},
					"lineItem": {
						"styles": {
							"variantTitle": {
								"color": "#262226"
							},
							"title": {
								"color": "#262226"
							},
							"price": {
								"color": "#262226"
							},
							"fullPrice": {
								"color": "#262226"
							},
							"discount": {
								"color": "#262226"
							},
							"discountIcon": {
								"fill": "#262226"
							},
							"quantity": {
								"color": "#262226"
							},
							"quantityIncrement": {
								"color": "#262226",
								"border-color": "#262226"
							},
							"quantityDecrement": {
								"color": "#262226",
								"border-color": "#262226"
							},
							"quantityInput": {
								"color": "#262226",
								"border-color": "#262226"
							}
						}
					}
				},
			});
		});
	}
}

export default shopifyCollectionEmbed